module.exports = __webpack_public_path__ + "img/xpm.c7ac994e.svg";